import { makeBetterEnum } from './betterEnum';

export const PermissionType = makeBetterEnum(
  'Admin',
  'AnyUser',
  'ApproveDataset',
  'ApproveDatasource',
  'ApproveFootprint',
  'CorporateAdmin',
  'EditCalculation',
  'EditProductFootprint',
  'EditReport',
  'EditReportQuestionInstance',
  'FinanceAdmin',
  'FinanceReadOnly',
  'ManageCompanyTags',
  'ManageDataset',
  'ManageDatasource',
  'ManageDisclosures',
  'ManageFund',
  'ManageMarketplacePurchases',
  'ManageMeasurement',
  'ManageOrgHierarchy',
  'ManageReductionPlans',
  'ManageSingleSignOn',
  'ManageSuppliers',
  'ViewAuditDetail',
  'ViewCalculation',
  'ViewEmployeeReport',
  'ViewFootprint',
  'ViewFootprintDetail',
  'ViewFootprintExport',
  'ViewLearningHub',
  'ViewProductFootprint',
  'ViewReductions',
  'ViewReport',
  'ViewReportQuestionInstance',
  'WatershedAdmin'
);

export type PermissionType =
  (typeof PermissionType)[keyof typeof PermissionType];

export const PermissionObjectType = makeBetterEnum(
  'Dataset',
  'Datasource',
  'Footprint',
  'FootprintExport',
  'Fund',
  'ReportQuestionInstance',
  'Report'
);

export type PermissionObjectType =
  (typeof PermissionObjectType)[keyof typeof PermissionObjectType];

export const PermissionExemptionReason = makeBetterEnum(
  'AnyUserAllowed',
  'CheckedInService'
);

export type PermissionExemptionReason =
  (typeof PermissionExemptionReason)[keyof typeof PermissionExemptionReason];
